import { render, staticRenderFns } from "./FeatureInfosPanelCustom.vue?vue&type=template&id=18bba184&scoped=true"
import script from "./FeatureInfosPanelCustom.vue?vue&type=script&lang=ts"
export * from "./FeatureInfosPanelCustom.vue?vue&type=script&lang=ts"
import style0 from "./FeatureInfosPanelCustom.vue?vue&type=style&index=0&id=18bba184&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bba184",
  null
  
)

export default component.exports